module.exports = __webpack_public_path__ + "img/Sprechfunkbetriebstrupp.cf45f4b2.svg";